const BUNDLE_QUANTITY_MODAL = 'BUNDLE_QUANTITY_MODAL';

export default BUNDLE_QUANTITY_MODAL;
